import React, { Component } from "react";
import MainPicture from "../Section/MainPicture";
import image from './img/open-source.png';
import LeftPictureBackground from "../Section/LeftPictureBackground";
import symfony from "./img/symfony-logo-compressor.png";
import styles from "./TechnologiesWeb.module.scss";
import nodejs from "./img/nodejs-compressor.png";
import react from "./img/react-logo-compressor.png";
import angular from "./img/angular-logo.png";
import plus from "./img/plus.png";
import Contact from "../Contact/Contact";

class TechnologiesWeb extends Component {
    discover(data, title) {
        if(data != "") {
            return  <a  href={data} title={'En savoir plus sur '+title} className="btn btn-primary">En savoir plus</a>;
        }
    }
    render() {
    let title = "Application Web";
    let goto = "En découvrir plus";
    let alt = "Technologies pour le Web et le Mobile";
    let description = ["Nous utilisons des ", <strong>technologies Web open-source</strong>," reconnues qui émane de la coopération de communautés fortes. Cela nous assure la qualité des technologies employés ainsi que la pérénnité des solutions Web que nous développons"];
        let description2 = ["Pour ", <strong>mener à bien votre projet</strong>," nous sommes amenés à utiliser de nombreuses technologies au quotidien pour répondre à vos contraintes qu'elles soient volumétriques ou technologiques.", <br />, <br />,
        "Ainsi nous pouvons être amenés à utiliser les technologies Open-source suivantes: ElasticSearch (Moteur de recherche ultra performant), MongoDB, Maria DB, Redis, RabitMQ, Docker, Nginx, Hadoop, ...", <br />,<br />, "Nous prenons à coeur d'utiliser la technologie adaptée à votre besoin."];
   
    let services = [
        {
            title: 'Symfony',
            subtitle: 'Framework de développement professionnel',
            image: symfony,
            description: [<a href="https://symfony.com/" title="Site officiel de Symfony" target="_blank">Symfony</a>, 
            " est un ensemble de composants Open-source Français. Nos équipes sont, depuis de nombreuses années, des ", 
            <strong>experts en développement Symfony</strong>,". Nous réalisons de nouveaux projets à l'aide de cette base. Nous pouvons aussi ", <strong>reprendre des projets Symfony existants</strong>,".",
            <br />, <br />, "De nombreux projets et sites reconnus mondialement sont réalisés pour tout ou partie avec Symfony comme: BlaBlaCar, Spotify, Vogue, Total, ...", <br />
            ],
            url: ''
        },
        {
            title: 'Node.js',
            subtitle: 'Du javascript léger et efficace',
            image: nodejs,
            description: [<a href="https://nodejs.org" title="Site officiel de Symfony" target="_blank">Node.js</a>, 
            " est une plateforme javascript développée à partir du moteur javascript de Chrome. Cette technologie permet de développer des applications rapides, robustes, facilement évolutives avec une excellente capacité à monter en charge.  ", 
            <br />, <br />, "De nombreux projets et sites reconnus mondialement sont réalisés à l'aide de Node.js comme par exemple: Paypal, E-bay, LinkedIn, Google, Netflix, ...", <br />,
            <br />, "Après analyse de votre projet, de vos besoins et de vos contraintes, nous définissons l'architecture technique Web et le cas échéant, nous réalisons tout ou partie de la solution en Node.js."
            ],
            url: ''
        },
        {
            title: 'React',
            subtitle: 'Une librairie moderne pour les interfaces utilisateur',
            image: react,
            description: [<a href="https://facebook.github.io/react" title="Site officiel de Symfony" target="_blank">React</a>, 
            " est une technologie développée par Facebook pour optimiser le ", <strong>développement Web ou Mobile</strong>, " des interfaces utilisateur.", 
            <br />, <br />, "En plus d'être extrèmement flexible, cette librairie permet une très grande évolutivité à faible coût. React est le socle de développement de la technologie Facebook React Native qui permet de développer des applications Mobildes applications mobiles puissantes."
            ],
            url: ''
        },
        {
            title: 'React Native',
            subtitle: 'Créer des applications mobiles iOS & Android Native',
            image: react,
            description: [<a href="https://facebook.github.io/react-native/" title="Site officiel de Symfony" target="_blank">React Native</a>, 
            " est une technologie développée par Facebook pour ", <a href="/application-mobile" title="Création d'app mobile">créer des applications mobiles</a>,". A partir du language React, React Native permet de construire des applications iOS et Android en language natif (Donc avec d'excellentes performances)"
            ,<br />, <br />, "De nombreuses applications mobiles sont créées à partir de React Native comme par exemple: Facebook, Instagram, Skype, Airbnb, Baidu, Walmart, ...", <br />, <br />, "Nous faisons du développement d'application mobile en React Native afin de vous proposer le meilleur des applications mobiles pour un budget adapté !" ],
            url: ''
        },
        {
            title: 'AngularJS',
            subtitle: 'Framework pour développer des applications web',
            image: angular,
            description: [<a href="https://angular.io" title="Site officiel de Symfony" target="_blank">AngularJS</a>, 
            " est une technologie développée par Google pour ", <a href="/application-web" title="Création de web app">créer des applications web et mobile</a>,".",
            
            "De nombreuses applications web et mobiles sont créées à partir d'AngularJS' comme par exemple: Youtube, ProtonMail, ...", <br />, <br /> ],
            url: ''
        }

    ];
    let servicesHmtlList = (
        <div>
            {services.map((service,index) =>
                <section className={styles.serviceSection}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-12">

                                <div className={`row row-bottom-padded-md row-top-padded-md ${styles.serviceContent} ${(index%2?'flex-row-reverse':'flex-row')}`}>
                                    <div className='col-md-4 text-center  align-self-stretch d-flex'>
                                    <img src={service.image} alt={service.title} className={`text-sm-center img-fluid  align-self-center ${styles.projectimg}`}/>
                                    </div>
                                    <div className="col-md-8">
                                        <h2 className="text-center text-md-left p-0 col-12 mb-2">{service.title}</h2>
                                        <h3 className="text-center text-md-left p-0 col-12">{service.subtitle}</h3>
                                        <p className="text-justify align-items-center">
                                        {service.description}
                                        </p>
                                        <div className="col-md-12 p-0 d-flex justify-content-md-start justify-content-center">
                                            {this.discover(service.url, service.title)}
                                            <a  href="/contact" title={'Demander un devis '+service.title}><button className="btn btn-devis">Demander un devis</button></a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            )}
        </div>

    );


    return (
      <div className="generic-services">
        <MainPicture title="Des technologies Open-Source" description={description} picture={image} alt={alt} />
        <div className="serviceList">
            {servicesHmtlList}
        </div>
        <MainPicture title="Mais ce n'est pas tout..." description={description2} picture={plus} alt={alt} />
        <Contact />
      </div>
    );
  }
}

export default TechnologiesWeb;



// WEBPACK FOOTER //
// ./src/components/Page/TechnologiesWeb.jsx